const rawBackendUrl = (process.env.REACT_APP_BACKEND_URL || "").trim();
const normalizedBackendUrl = rawBackendUrl.replace(/\/+$/, "");
const isLocalBackend =
  /^https?:\/\/(localhost|127\.0\.0\.1)(:\d+)?$/i.test(normalizedBackendUrl);

export const API_BASE_URL =
  normalizedBackendUrl && !(process.env.NODE_ENV === "production" && isLocalBackend)
    ? `${normalizedBackendUrl}/api`
    : "/api";
